import type { NextPage } from 'next';
import { getOrCreateContentfulClient } from '@graphql/client';
import type { ArticleKind } from '@graphql/hooks/article-page';
import { GetRecentArticlesByKind } from '@graphql/hooks/article-topic-page';
import { useUIStore } from '@lib/store/useUIStore';
import { TEXT } from '@lib/utils/text';
import { ArticlePageTemplate } from '@page-templates/article-page';
import type { ArticleStaticProps } from '@server/helpers/article';
import { getArticleVideoStaticProps } from '@server/helpers/article-video';
import { isPrd } from '@shared/util/env';
import { LINK } from '@shared/util/link';
const kind: ArticleKind = 'Video';
const Money101Article: NextPage<ArticleStaticProps> = props => {
  const {
    webview
  } = useUIStore();
  return <ArticlePageTemplate kind={kind} breadcrumbs={[{
    text: TEXT.money101,
    link: LINK.money101(webview.isWebview)
  }]} {...props} data-sentry-element="ArticlePageTemplate" data-sentry-component="Money101Article" data-sentry-source-file="[slug].tsx" />;
};
export const getStaticPaths = async () => {
  const client = getOrCreateContentfulClient(TEXT.money101);

  // get popular articles and generate static pages for them
  const {
    data
  } = await GetRecentArticlesByKind(client, {
    variables: {
      kind,
      count: 5
    }
  });
  const paths = data?.articleCollection?.items?.map(article => ({
    params: {
      slug: article?.slug
    }
  }));
  return {
    paths: isPrd() ? paths : [],
    fallback: 'blocking'
  };
};
export const getStaticProps = getArticleVideoStaticProps('Video');
export default Money101Article;